module.exports = __webpack_public_path__ + "static/bkb-logo-5e73664d81c2479f82358affbbaacad1.svg";